import type { OAuthClient } from 'src/interfaces/oauth'
import type { State } from '../reducers/types'

/**
 * Every selector here returns a stored value by reference. Never build an object or array
 * literal in a selector — each consuming `useSelector` would re-render on every dispatch.
 *
 * Active/disabled status is deliberately not a selector: `isOAuthClientActive` in
 * `utils/oauthClient.ts` is a pure function, so it stays testable without a store and cannot be
 * mistaken for a memoized value.
 */
export const getOAuthClient = (state: State): OAuthClient | null => {
  return state.oauthClient.client
}

export const getOAuthClientPartnerId = (state: State): string | null => {
  return state.oauthClient.partnerId
}

export const getOAuthClientLoading = (state: State): boolean => {
  return state.oauthClient.loading
}

export const getOAuthClientLoaded = (state: State): boolean => {
  return state.oauthClient.loaded
}

export const getOAuthClientError = (state: State): string | null => {
  return state.oauthClient.error
}

export const getOAuthClientSaving = (state: State): boolean => {
  return state.oauthClient.saving
}

export const getOAuthTokensRevoking = (state: State): boolean => {
  return state.oauthClient.revoking
}
